// Be Autos
enum BeAutoAssigningDriver {
  ASSIGNING_DRIVER = 105,
  NO_DRIVERS_AVAILABLE = 106,
  RIDE_ACCEPTED = 107,
}

/**

Trạng thái của 1 chuyến đi

*/

enum BEAutoRideStatus {
  /// request has been sent

  requested = 0,

  /// request has been accepted by the driver

  accepted = 1,

  /// ride has started

  started = 2,

  /// ride has ended

  ended = 3,

  /// request rejected by server

  rejectedBySystem = 4,

  /// request is canceled by customer while no driver has accepted it yet

  requestCanceledByCustomer = 5,

  /// request timed out

  timedout = 6,

  /// request was accepted by another driver

  acceptedByOtherDriver = 7,

  /// ride was accepted and then cancelled by driver

  rideCancelledByDriver = 8,

  /// request was closed when the driver accepted other request

  closed = 9,

  /// backend say "this status don't exists"

  canceledAfterAccepted = 10,

  /// ride was cancelled by customer after it was accepted by a driver

  rideCanceledByCustomer = 13,

  /// driver arrived at pickup point

  arrived = 14,
}

const BEAutoRideStatusText: any = {
  [BEAutoRideStatus.requested]: "ride.trip_status.finding_driver",
  [BEAutoRideStatus.accepted]: "ride.trip_status.accepted",
  [BEAutoRideStatus.started]: "ride.trip_status.started",
  [BEAutoRideStatus.ended]: "Đã kết thúc hành trình",
  [BEAutoRideStatus.rejectedBySystem]: "Không tìm thấy tài xế",
  [BEAutoRideStatus.requestCanceledByCustomer]: "Đã hủy chuyến",
  [BEAutoRideStatus.timedout]: "Không tìm thấy tài xế",
  [BEAutoRideStatus.acceptedByOtherDriver]: "Đã tìm thấy tài xế",
  [BEAutoRideStatus.rideCancelledByDriver]:
    "ride.trip_status.cancelled_by_driver",
  [BEAutoRideStatus.closed]: "Đã hủy chuyến",
  [BEAutoRideStatus.canceledAfterAccepted]: "Đã hủy chuyến",
  [BEAutoRideStatus.arrived]: "ride.trip_status.arrived",
}

export { BeAutoAssigningDriver, BEAutoRideStatus, BEAutoRideStatusText }
